import { ElementRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { combineLatest, Observable } from 'rxjs';
import { tap, map, finalize, startWith } from 'rxjs/operators';
import { BaseFormComponent, FormAction } from '../../../shared/components/base/base-form.component';
import { ProductLocationDto, } from 'src/app/services/wms.service';
export class ProductLocationFormComponent extends BaseFormComponent {
    constructor(productLocationService, locationService, dialogRef, productService, data) {
        super(dialogRef, data);
        this.productLocationService = productLocationService;
        this.locationService = locationService;
        this.dialogRef = dialogRef;
        this.productService = productService;
        this.data = data;
        this.locationControl = new FormControl();
        this.model = new ProductLocationDto();
    }
    ngOnInit() {
        //setTimeout(() => this.cancelButton.nativeElement.focus());
        const sku = this.data.sku;
        const countryCode = this.data.countryCode;
        const locationId = this.data.locationId;
        this.currentStore = this.data.storeCode;
        this.productService.getBySku(sku, countryCode)
            .subscribe((resp) => this.selectedProduct = resp);
        this.isLoading = true;
        this.locations$ = this.locationService
            .getAll(countryCode, 'id asc', 0, 10000)
            .pipe(map(x => x.items), tap(items => {
            if (locationId) {
                this.selectedLocation = items.find(x => x.id === locationId);
                this.locationControl.setValue(this.selectedLocation);
            }
        }), finalize(() => this.isLoading = false));
        this.filteredLocations = combineLatest([
            this.locations$,
            this.locationControl.valueChanges.pipe(startWith(''))
        ]).pipe(map(([locations, value]) => { var _a; return this._filter(locations, typeof value === 'string' ? value : ((_a = value) === null || _a === void 0 ? void 0 : _a.code) || ''); }));
    }
    ;
    ngAfterViewInit() {
        var _a;
        (_a = this.cancelButton.nativeElement) === null || _a === void 0 ? void 0 : _a.focus();
    }
    _filter(locations, value) {
        const filterValue = value ? value.toLowerCase() : '';
        return locations.filter(location => location.code.toLowerCase().includes(filterValue));
    }
    locationChange(event) {
        console.log('locationChange', event.option.value);
        this.selectedLocation = event.option.value;
    }
    displayLocationCode(location) {
        return location ? location.code : '';
    }
    enableSendBtn() {
        return (this.selectedLocation);
    }
    getModel() {
        throw new Error('Method not implemented.');
    }
    send() {
        this.model.storeCode = this.currentStore;
        this.model.locationId = this.selectedLocation.id;
        this.model.locationCode = this.selectedLocation.code;
        this.model.productId = this.selectedProduct.id;
        this.model.productName = this.selectedProduct.name;
        this.model.sku = this.selectedProduct.sku;
        this.model.ean = this.selectedProduct.barCode;
        this.model.imageUrl = null;
        //console.log('send', this.model);
        // crear / actulizar el wms... 
        this.isLoading = true;
        var obs = (this.action == FormAction.create) ? this.create() : this.edit();
        obs.pipe(finalize(() => this.isLoading = false))
            .subscribe(result => {
            // paso el dto actualizado a la pantalla de picking y cierro modal
            this.dialogRef.close(result);
        });
    }
    create() {
        return this.productLocationService.create(this.model);
    }
    edit() {
        return this.productLocationService.update(this.model);
    }
}
